/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/* Start boost 219911 */
if(boostSDAppConfig?.filterSettings) {
  boostSDAppConfig.filterSettings.filterAvoidStickyHeader = ['.shopify-section.shopify-section-group-header-group.site-header-wrapper'];
}
/* End boost 219911 */
const customize = {
  updateBtns: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Show addition Data',
      enabled: true,
      apply: () => ({
        afterRender(element){
          try {
            let data = element.getParams()?.props?.product || element.getParams()?.props?.productData || element.getParams()?.props?.data;
            let productItem = document.querySelector('[data-product-id="'+ data.id +'"]');
            if (!productItem) return;
            
            const skuHtml = '<div class="boost-sd__product-sku" style="width: 100%;">PART#: ' + data.skus[0] + '</div>';
            if (!productItem.querySelector('.boost-sd__product-sku') && data.skus.length > 0) {
              if (productItem.querySelector('.boost-sd__product-title')) productItem.querySelector('.boost-sd__product-title').insertAdjacentHTML('afterend', skuHtml);
            }
          } catch (e) {
            console.error(e);
          }
        }
      }),
    });
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateBtns]);